export default __webpack_public_path__ + "static/media/logo-text.9216aaf8.png";